import { render, staticRenderFns } from "./ApplicationWithDrawCourseWarning.vue?vue&type=template&id=bed1f720"
import script from "./ApplicationWithDrawCourseWarning.vue?vue&type=script&lang=js"
export * from "./ApplicationWithDrawCourseWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports